export type Variant = "original" | "1" | "2";

const DEFAULT_VARIANT: Variant = "1";

function readVariantFromUrl(): Variant {
  if (typeof window === "undefined") return DEFAULT_VARIANT;
  const raw = new URLSearchParams(window.location.search).get("v");
  if (raw === "0" || raw === "original") return "original";
  if (raw === "1") return "1";
  if (raw === "2") return "2";
  return DEFAULT_VARIANT;
}

let current: Variant = readVariantFromUrl();

export function initVariant(): void {
  if (typeof document === "undefined") return;
  current = readVariantFromUrl();
  document.documentElement.dataset.variant = current;
}

export function getVariant(): Variant {
  return current;
}
